import type { ReactElement } from "react";
import { SwotPageSkeleton } from "@swot";

export function CmtsRouteLoadingFallback(props: { readonly label?: string | undefined }): ReactElement {
  return <SwotPageSkeleton label={props.label ?? "Loading CMTS workspace"} rows={4} />;
}
